import { useCallback, useState } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { MembershipBenefitReference } from '@appTypes/membershipBenefitReferenceType';
import { useAuth0Token } from './useAuth0Token';

interface FavoriteBenefitsResponse {
  items: MembershipBenefitReference[];
}

interface ReturnType {
  benefits: MembershipBenefitReference[] | undefined;
  isLoading: boolean;
  error: boolean;
  getFavoriteBenefits: () => void;
}

export const useFetchFavoriteBenefits = (hasActiveCampaign = false): ReturnType => {
  const [benefits, setBenefits] = useState<MembershipBenefitReference[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { simpleToken } = useAuth0Token();

  const getFavoriteBenefits = useCallback(async () => {
    if (!simpleToken) return;
    setIsLoading(true);
    try {
      const response = await apiClient.get<FavoriteBenefitsResponse>(ApiType.apimNafNoApi, {
        url: ApiPaths[ApiType.apimNafNoApi].benefits.list,
        params: { FavoritesOnly: true, ...(hasActiveCampaign && { HasActiveCampaign: true }), Take: 100 },
      });
      setBenefits(response.data?.items ?? []);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }, [simpleToken, hasActiveCampaign]);

  return { benefits, isLoading, error, getFavoriteBenefits };
};
